export default function AddAccont({ color = "#FAFAFA" }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3335 14C1.33344 12.9736 1.62959 11.9689 2.18639 11.1066C2.7432 10.2443 3.53701 9.56098 4.47256 9.13868C5.40811 8.71637 6.44565 8.573 7.46067 8.72578C8.47568 8.87857 9.42505 9.321 10.1948 10M12.6668 10.6667V14.6667M14.6668 12.6667H10.6668M10.0002 5.33333C10.0002 7.17428 8.50778 8.66667 6.66683 8.66667C4.82588 8.66667 3.3335 7.17428 3.3335 5.33333C3.3335 3.49238 4.82588 2 6.66683 2C8.50778 2 10.0002 3.49238 10.0002 5.33333Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
